module.exports = __webpack_public_path__ + "img/account.rate.weekly.3232809e.png";